export function selectDoctors(doctors) {
  return { any: false, doctors };
}

export function selectAnyDoctor() {
  return { any: true, doctors: [] };
}

export function isEmpty(selectedDoctors) {
  if (selectedDoctors == null) {
    return true;
  }

  return !selectedDoctors.any && selectedDoctors.doctors.length === 0;
}

export function getPreferredDoctors(client, doctors) {
  if (client == null) {
    return selectDoctors([]);
  }

  if (client.any_doctor) {
    return selectAnyDoctor();
  }

  const doc = new Set(client.doctors?.map((d) => d.id) ?? []);

  return selectDoctors(doctors?.filter((d) => doc.has(d.id)) ?? []);
}
